import styles from './read-only-value.module.css'
import * as React from 'react'
import { Text } from 'components/ds'

const MIXED_LABEL = 'Mixed'
const EMPTY_LABEL = '—'

type Props = {
  value: React.ReactNode
  mixed?: boolean
  align?: 'left' | 'center'
}

const isEmpty = (value: React.ReactNode): boolean =>
  value === null || value === undefined || value === ''

/**
 * Plain-text display for a read-only metadata field value — no input border
 * or fill, per the Radix DS look. Wraps instead of clipping, so a long value
 * (e.g. several composer names) is fully visible without any interaction.
 * Shows a dash instead of leaving the field blank when there's no value.
 */
const ReadOnlyValue = ({
  value,
  mixed,
  align = 'left',
}: Props): React.ReactElement => (
  <div className={styles.wrapper}>
    <Text
      as="div"
      size="2"
      align={align}
      color={mixed || isEmpty(value) ? 'gray' : undefined}
      className={styles.text}
    >
      {mixed ? MIXED_LABEL : isEmpty(value) ? EMPTY_LABEL : value}
    </Text>
  </div>
)

export default ReadOnlyValue
